// extracted by mini-css-extract-plugin
export var form = "form-module--form--HtUmr";